import React from 'react';
import { useFullScreenHandle } from 'react-full-screen';

export default function injectFullScreen(Component) {
  const InjectedFullScreen = function (props) {
    //   const todos = useTodos(props);
    const handle = useFullScreenHandle();
    return <Component {...props} handle={handle} />;
  };
  return InjectedFullScreen;
}
